import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, fmtErr } from "../lib/api";
import { toast } from "sonner";

const STATUS_COLORS = {
  draft: "var(--c-muted)", sent: "var(--c-accent)", acknowledged: "var(--c-amber)", response_received: "var(--c-green)",
  under_review: "var(--c-amber)", accepted: "var(--c-green)", rejected: "var(--c-red)",
};

export default function ProjectScm({ projectId }) {
  const nav = useNavigate();
  const [inquiries, setInquiries] = useState(null);

  useEffect(() => {
    api.get("/scm/inquiries", { params: { project_id: projectId } })
      .then(({ data }) => setInquiries(data))
      .catch((e) => toast.error(fmtErr(e)));
  }, [projectId]);

  if (inquiries === null) return <div className="font-mono text-xs text-[var(--c-muted)] tracking-widest p-4">LOADING INQUIRIES…</div>;

  return (
    <div className="border border-[var(--c-border)] rounded-sm bg-[var(--c-surface)]" data-testid="project-scm-tab">
      <div className="px-4 py-2.5 border-b border-[var(--c-border)] text-xs font-medium text-[var(--c-text)]">
        SCM Inquiries · {inquiries.length}
      </div>
      {inquiries.map((q) => (
        <div key={q.id} onClick={() => nav(`/scm/inquiries/${q.id}`)} data-testid={`project-scm-row-${q.inquiry_id}`}
          className="flex items-center gap-4 px-4 py-3 border-b border-[var(--c-border)]/60 last:border-0 hover:bg-[var(--c-border)]/25 cursor-pointer transition-colors duration-150">
          <span className="font-mono text-xs text-[var(--c-accent)] w-56 shrink-0 truncate">{q.inquiry_id}</span>
          <span className="text-xs text-[var(--c-text)] flex-1 truncate">{q.component}</span>
          <span className="text-[10px] font-mono uppercase tracking-wider px-1.5 py-0.5 rounded-sm border"
            style={{ color: STATUS_COLORS[q.status], borderColor: `color-mix(in srgb, ${STATUS_COLORS[q.status]} 25%, transparent)`, backgroundColor: `color-mix(in srgb, ${STATUS_COLORS[q.status]} 10%, transparent)` }}>
            {q.status.replace(/_/g, " ")}
          </span>
          <span className="font-mono text-xs text-[var(--c-muted)]">{q.expected_date || "—"}</span>
          <span className={`font-mono text-xs ${q.overdue ? "text-[var(--c-red)]" : "text-[var(--c-muted)]"}`}>
            {q.days_remaining != null ? `${q.days_remaining}d` : "—"}
          </span>
        </div>
      ))}
      {inquiries.length === 0 && (
        <div className="px-4 py-8 text-center text-xs text-[var(--c-muted)]" data-testid="project-scm-empty">
          No inquiries for this project. SCM auto-check creates draft inquiries when the project is finalized (AI identifies long-lead bought-outs).
        </div>
      )}
    </div>
  );
}
